import { Navigate } from 'react-router';

import styled from '@emotion/styled';

import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import { UserRoleTypes } from '../../../enums/enums';
import { useAppSelector } from '../../../redux/store';
import { WAITLIST_SUBMISSIONS } from '../../../routes/routeConstants';
import DashboardChart from './DashboardChart';
import DashboardOverview from './DashboardOverview';

const Dashboard = () => {
  const { authData } = useAppSelector((state) => state.auth);

  if (authData?.user?.accountRole === UserRoleTypes.WAITLIST_ADMIN) {
    return <Navigate to={`/${WAITLIST_SUBMISSIONS}`} />;
  }

  return (
    <Page title='Logirate | Dashboard'>
      <PageLayout>
        <Container>
          <DashboardOverview />
          <DashboardChart />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default Dashboard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
